
const observer = new MutationObserver(() => {
  const el = document.querySelector('.mfp-ready');

  if (el) {
    triggered = true;
     document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
    setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
    }, 1000);
    setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
    }, 5000);
  }

  const list = document.querySelectorAll(
    "[bss-b2b-quickview-product-form] .bss-b2b-cart-item-qty-table"
    );

    list.forEach((el, index) => {
        if (index > 0) {
            el.style.display = "none";
        }
    });


});

observer.observe(document.body, {
  childList: true,
  subtree: true
});